import { PropsWithChildren } from 'react';
import { Avatar, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useResponsive } from '@/hooks/useResponsive';
import { StyledTaskRow } from './TaskRow.styles';
import { TaskSectionProps } from './types';

const TaskRow = ({ icon, title, subtitle, tooltip, children }: PropsWithChildren<TaskSectionProps>) => {
    const { isMobile } = useResponsive();
    return (
        <StyledTaskRow>
            <div className="task-row-label-section">
                <Avatar className="task-row-icon" icon={icon}/>
                <div className="task-row-label-section-content">
                    <div className="task-row-label">
                        {title}
                        {tooltip && (
                            <Tooltip 
                                title={tooltip}
                                placement={isMobile ? "top" : "right"}
                            >
                                <InfoCircleOutlined/>
                            </Tooltip>
                        )}
                    </div>
                    {subtitle && <div className="task-row-subtitle">{subtitle}</div>}
                </div>
            </div>
            <div className="task-row-values-wrapper">
                {children}
            </div>
        </StyledTaskRow>
    );
};

export default TaskRow;